import React from 'react';
import { AutocompleteEmptyPlaceholderProps } from './empty-placeholder.props';
import { AutocompleteAddNewItemButton } from '../add-new-item-button/add-new-item-button';
import { Text } from 'common/common-components.styled';

export const AutocompleteEmptyPlaceholder = ({ placeholder, addNewItemButton }: AutocompleteEmptyPlaceholderProps) => {
  return (
    <div>
      <Text bottom='10'>{placeholder || 'Keine Optionen'}</Text>
      {!!addNewItemButton && <AutocompleteAddNewItemButton {...addNewItemButton} />}
    </div>
  );
};
